if (customElements.get('pairs-card') === undefined) {
  class PairsCard extends HTMLElement {
    constructor() {
      super();
      this.onAtcClickBind = this.onAtcClick.bind(this);
      this.abortController = null;
    }

    connectedCallback() {
      this.atcButton = this.querySelector('[data-pairs-atc]');
      if (!this.atcButton) return;
      this.textEl = this.atcButton.querySelector('.pairs-card__atc-text');
      this.spinnerEl = this.atcButton.querySelector('.loading__spinner');
      this.atcButton.addEventListener('click', this.onAtcClickBind);
    }

    disconnectedCallback() {
      if (this.atcButton) this.atcButton.removeEventListener('click', this.onAtcClickBind);
      // Abort any in-flight cart-add so the .then doesn't update detached
      // DOM nodes or publish a stale cartUpdate event after the element is gone.
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }

    setLoading(isLoading) {
      if (this.textEl) this.textEl.classList.toggle('pairs-card__atc-text--loading', isLoading);
      if (this.spinnerEl) this.spinnerEl.classList.toggle('hidden', !isLoading);
      if (this.atcButton) this.atcButton.disabled = isLoading;
    }

    onAtcClick() {
      const variantId = this.atcButton.dataset.variantId;
      if (!variantId) return;

      this.setLoading(true);

      // Request cart sections so the header cart-icon-bubble can re-render
      // via the native <cart-drawer>. UpCart currently intercepts /cart/add.js
      // and updates the badge directly, but this fallback keeps the header
      // count accurate if UpCart is ever removed, paused, or breaks.
      const cart = document.querySelector('cart-drawer');
      const sections = cart ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];

      // Cancel any previous in-flight add (rapid double-clicks) and prepare
      // an abort signal so disconnectedCallback can drop the response.
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      const config = fetchConfig('javascript');
      config.headers['Content-Type'] = 'application/json';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sections,
      });
      config.signal = signal;

      fetch(routes.cart_add_url, config)
        .then((res) => res.json())
        .then((response) => {
          if (signal.aborted) return;
          this.setLoading(false);

          if (response.status) {
            console.error('[pairs-card] cart add rejected:', response);
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'pairs-card',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            return;
          }

          if (cart && response.sections) cart.renderContents(response);

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pairs-card',
            productVariantId: variantId,
            cartData: response,
          });
        })
        .catch((err) => {
          // Aborted fetches throw AbortError — swallow silently, that's intentional teardown.
          if (err && err.name === 'AbortError') return;
          this.setLoading(false);
          console.error('[pairs-card] cart add failed:', err);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'pairs-card',
            productVariantId: variantId,
            errors: err && err.message,
          });
        });
    }
  }

  customElements.define('pairs-card', PairsCard);
}
